__turbopack_context__.v({
  "actions": "error-page-module__B543oW__actions",
  "brand": "error-page-module__B543oW__brand",
  "brandLogo": "error-page-module__B543oW__brandLogo",
  "brandText": "error-page-module__B543oW__brandText",
  "cable": "error-page-module__B543oW__cable",
  "cableLine": "error-page-module__B543oW__cableLine",
  "cableLoop": "error-page-module__B543oW__cableLoop",
  "cablePlug": "error-page-module__B543oW__cablePlug",
  "code": "error-page-module__B543oW__code",
  "content": "error-page-module__B543oW__content",
  "copy": "error-page-module__B543oW__copy",
  "description": "error-page-module__B543oW__description",
  "eyebrow": "error-page-module__B543oW__eyebrow",
  "panel": "error-page-module__B543oW__panel",
  "primaryAction": "error-page-module__B543oW__primaryAction",
  "secondaryAction": "error-page-module__B543oW__secondaryAction",
  "shell": "error-page-module__B543oW__shell",
  "title": "error-page-module__B543oW__title",
  "toolMark": "error-page-module__B543oW__toolMark",
  "toolMarkHandle": "error-page-module__B543oW__toolMarkHandle",
  "toolMarkHead": "error-page-module__B543oW__toolMarkHead",
  "visual": "error-page-module__B543oW__visual",
});
